import dayjs, { type Dayjs } from 'dayjs';

/** Inclusive `[from, to]` day range of the progress stats endpoints. */
export type StatsRange = [Dayjs, Dayjs];

export const DAY = 'YYYY-MM-DD';
export const DEFAULT_DAYS = 7;
export const MAX_DAYS_BACK = 90;

// The backend bounds the range by the UTC day — a local "today" is a day
// ahead of it right after midnight in Poland and would be rejected.
export const utcToday = () => dayjs(new Date().toISOString().slice(0, 10));

export const daysBack = (n: number): StatsRange => [
  utcToday().subtract(n, 'day'),
  utcToday(),
];

export const isOutOfRange = (day: Dayjs) =>
  day.isAfter(utcToday(), 'day') ||
  day.isBefore(utcToday().subtract(MAX_DAYS_BACK, 'day'), 'day');

export const RANGE_PRESETS = [7, 30, 90].map((n) => ({
  label: `Ostatnie ${n} dni`,
  value: () => daysBack(n),
}));

// Both ends always go out — the backend rejects a half-open range.
export const rangeQuery = ([from, to]: StatsRange) => ({
  from: from.format(DAY),
  to: to.format(DAY),
});
